import AddIcon from '@mui/icons-material/Add'
import IconButton from '@mui/material/IconButton'
import { FC } from 'react'
import { xxllncColor } from '../../layout/themes'

interface AddIconButtonProps {
    onClick?: () => void
}

const AddIconButton: FC<AddIconButtonProps> = ({ onClick }) => (
  <IconButton
    size="small"
    sx={{
      'ml': 1,
      'backgroundColor': xxllncColor.dark100,
      ':hover': {
        backgroundColor: xxllncColor.opBlue60,
      },
    }}
    onClick={onClick}
  >
    <AddIcon
      fontSize="small"
      sx={{
        color: 'white',
      }}
    />
  </IconButton>
)

export default AddIconButton